export default "/assets/images/badge-03.webp?5b05b0a3879a70793c9a4f619d72e21b";